export const initialMakePaymentRequest = {
  bookingReference: '',
  bookingJourneyReference: '',
  totalAmount: {
    amount: 0,
    currency: 'GBP',
    exchangeRate: 0,
    baseCurrency: "GBP"
  },
  cardDetail: {
    obscuredCardNumber: '',
    encryptedCardInformation: '',
    amount: 0,
    isEncrypted: false,
    isDirty: true,
    saveCard: false
  },
  recurringPayment: {
    recurringDetailReference: ''
  },
  promotionRedemption: {
    promoCode: '',
    promoDiscountAmount: 0
  },
  transactionType: '',
  businessTransactionType: '',
  quoteId: '',
  isPaidByInvoice: false,
  timeslotId: null,
  productTierId: null,
  flightDateTime: '',
  isCustomerService: false,
  shopperInfo: {
    browserInfo: {
      acceptHeader: '',
      userAgent: '',
      language: '',
      colorDepth: '',
      screenHeight: '',
      screenWidth: '',
      timeZoneOffset: null,
      javaEnabled: false
    },
    IP: '',
    billingAddress: {
      country: '',
      city: '',
      street: '',
      houseNumberOrName: '',
      stateOrProvince: '',
      postalCode: ''
    },
    email: ''
  },
  isUserLoggedIn: false,
  isBagTypeChanged: false,
  isBagCountChanged: false,
  loginType: '',
};
